import { render, staticRenderFns } from "./FormBuildersList.vue?vue&type=template&id=c0533838&scoped=true"
import script from "./FormBuildersList.vue?vue&type=script&lang=js"
export * from "./FormBuildersList.vue?vue&type=script&lang=js"
import style0 from "./FormBuildersList.vue?vue&type=style&index=0&id=c0533838&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0533838",
  null
  
)

export default component.exports